import BranchDetail from "../Branches/BranchDetail";
import BMReportDetail from "../BranchManager/BMReportDetail";
import {
  PopupInfoModel,
  EnumPopupFunctions,
  UserModel,
  ShiftPlanEmployee,
} from "../Managers/dataStructures";
import { getCurrentUser } from "../Managers/profileManager";
import AdminReportDetail from "../Reports/AdminReportDetail";
import ShiftDetail from "../Shifts/ShiftDetail";
import TLEmployeeDialog, {
  TLEmployeeDialogProps,
} from "../TeamLead/TLEmployeeDialog";
import TLLoginDialog from "../TeamLead/TLLoginDialog";
import ChangePassDialog from "../Users/ChangePassDialog";
import UserDetail from "../Users/UserDetail";
import AlertDialog from "./AlertDialog";

export default function PopUpScreen(
  item: PopupInfoModel,
  closePopupMenu: () => void,
  redirect: (item: PopupInfoModel) => void
) {
  function closePopup_() {
    closePopupMenu();
  }

  function redirectControl(redirectItem: PopupInfoModel) {
    redirect(redirectItem);
  }

  switch (item.ftype) {
    case EnumPopupFunctions.ADD_USER:
      return (
        <UserDetail
          fType={EnumPopupFunctions.ADD_USER}
          closePopup={closePopup_}
          popupItem={item}
          array_branches={
            item.array_branches !== undefined ? item.array_branches : []
          }
        />
      );
    case EnumPopupFunctions.EDIT_USER:
      return (
        <UserDetail
          fType={EnumPopupFunctions.EDIT_USER}
          user={item.item as UserModel}
          closePopup={closePopup_}
          popupItem={item}
          array_branches={
            item.array_branches !== undefined ? item.array_branches : []
          }
        />
      );
    case EnumPopupFunctions.USER_DETAIL:
      return (
        <UserDetail
          fType={EnumPopupFunctions.USER_DETAIL}
          user={item.item as UserModel}
          closePopup={closePopup_}
          popupItem={item}
          array_branches={
            item.array_branches !== undefined ? item.array_branches : []
          }
        />
      );

    case EnumPopupFunctions.ADD_BRANCH:
      return (
        <BranchDetail
          ftype={EnumPopupFunctions.ADD_BRANCH}
          closePopup={closePopup_}
          popupItem={item}
        />
      );
    case EnumPopupFunctions.BRANCH_DETAIL:
      return (
        <BranchDetail
          ftype={EnumPopupFunctions.BRANCH_DETAIL}
          branch={item.item}
          closePopup={closePopup_}
          popupItem={item}
        />
      );
    case EnumPopupFunctions.ADD_SHIFT:
      return (
        <ShiftDetail
          ftype={EnumPopupFunctions.ADD_SHIFT}
          shift={item.item}
          callBackHandler={closePopup_}
          popupItem={item}
        />
      );
    case EnumPopupFunctions.EDIT_SHIFT:
      return (
        <ShiftDetail
          ftype={EnumPopupFunctions.EDIT_SHIFT}
          shift={item.item}
          callBackHandler={closePopup_}
          popupItem={item}
        />
      );
    case EnumPopupFunctions.TL_USER_LOGIN_DIALOG:
      const user: UserModel = (item.item as ShiftPlanEmployee).user;
      return (
        <TLLoginDialog
          user={user}
          item={item}
          props={item.props}
          redirectDialog={redirectControl}
          closeDialog={closePopup_}
        />
      );
    case EnumPopupFunctions.TL_USER_LOGIN_DIALOG_REDIRECTION:
      const props = item.props as TLEmployeeDialogProps;
      return (
        <TLEmployeeDialog
          //ftype={EnumPopupFunctions.TL_USER_LOGIN_DIALOG}
          shift_plan_employee={item.item}
          startPauseShift={props.startPauseShift}
          endShift={props.endShift}
          closeDialog={closePopup_}
          //callBackHandler={closePopup_}
        />
      );
    case EnumPopupFunctions.TL_FORCE_CLOSE_DIALOG: {
      //const user: UserModel = (item.item as ShiftPlanEmployee).user;
      return (
        <TLLoginDialog
          user={getCurrentUser()}
          item={item}
          redirectDialog={redirectControl}
          closeDialog={closePopup_}
        />
      );
    }
    case EnumPopupFunctions.TL_END_SHIFT_DIALOG: {
      return (
        <TLLoginDialog
          user={getCurrentUser()}
          item={item}
          redirectDialog={redirectControl}
          closeDialog={closePopup_}
        />
      );
    }
    case EnumPopupFunctions.BM_REPORT_DETAIL: {
      return <BMReportDetail item={item} closeDialog={closePopup_} />;
    }
    case EnumPopupFunctions.ADMIN_REPORT_DETAIL: {
      return <AdminReportDetail item={item} closeDialog={closePopup_} />;
    }

    case EnumPopupFunctions.ALERT_DIALOG: {
      return <AlertDialog item={item.item} closeDialog={closePopup_} />;
    }

    case EnumPopupFunctions.MAIN_MENU_PASSWORD_REQUIRED_LOGIN_DIALOG:
      return (
        <TLLoginDialog
          user={item.item as UserModel}
          item={item}
          redirectDialog={redirectControl}
          closeDialog={closePopup_}
        />
      );

    case EnumPopupFunctions.CHANGE_PASSWORD_SELF: {
      return (
        <ChangePassDialog
          user={getCurrentUser()}
          closeDialog={closePopup_}
          isAdmin={false}
        />
      );
    }

    case EnumPopupFunctions.CHANGE_PASSWORD_ADMIN: {
      return (
        <ChangePassDialog
          user={item.item}
          closeDialog={closePopup_}
          isAdmin={true}
        />
      );
    }

    case EnumPopupFunctions.UNKNWON:
      return null;
  }
}
